import React from "react";
import { ImageIcon, ShapesIcon, Trash2Icon, TypeIcon } from "lucide-react";
import { cliparts } from "../../data/designAssets";
import type { DesignElement, MockupDef } from "../../types/configurator";
interface LayerListProps {
  elements: DesignElement[];
  mockup: MockupDef;
  selectedId: string | null;
  onSelect: (el: DesignElement) => void;
  onRemove: (id: string) => void;
}
export function LayerList({
  elements,
  mockup,
  selectedId,
  onSelect,
  onRemove
}: LayerListProps) {
  if (!elements.length) {
    return <p className="text-sm text-muted" data-id="element-313" data-mp="2q0xoi4xkhbf5">Aucun élément pour l'instant. Importez un logo, ajoutez un texte ou un pictogramme.</p>;
  }
  return <ul className="-mx-1" data-id="element-314" data-mp="2l6tc365j8b6o">
      {[...elements].reverse().map(el => {
      const zone = mockup.zones.find(z => z.id === el.zoneId);
      const Icon = el.kind === "image" ? ImageIcon : el.kind === "text" ? TypeIcon : ShapesIcon;
      const label = el.kind === "image" ? el.name : el.kind === "text" ? el.text || "Texte vide" : cliparts.find(c => c.id === el.clipartId)?.name ?? "Pictogramme";
      const selected = el.id === selectedId;
      return <li key={el.id} className="flex items-center" data-id="element-315" data-mp="272vf0q74yh9p">
            <button type="button" onClick={() => onSelect(el)} aria-pressed={selected} className={`flex min-w-0 flex-1 items-center gap-3 px-2 py-2 text-left text-sm transition-colors duration-150 ease-out ${selected ? "bg-ink text-paper" : "hover:bg-mist"}`} data-id="element-316" data-mp="1td1jxq51f0rj">
              <Icon size={16} className="shrink-0" aria-hidden="true" data-id="element-317" data-mp="1addxndysj6s6" />
              <span className="min-w-0 flex-1 truncate font-bold" data-id="element-318" data-mp="1af8heoybssuo">{label}</span>
              <span className={`shrink-0 text-xs ${selected ? "text-paper/70" : "text-muted"}`} data-id="element-319" data-mp="1fda2fffbb28s">{zone?.name}</span>
            </button>
            <button type="button" aria-label={`Supprimer ${label}`} onClick={() => onRemove(el.id)} className="flex h-9 w-9 shrink-0 items-center justify-center text-muted transition-colors duration-150 ease-out hover:text-cherry" data-id="element-320" data-mp="34pklbc8vfg1d">
              <Trash2Icon size={15} aria-hidden="true" data-id="element-321" data-mp="33cm6ti2ob9wo" />
            </button>
          </li>;
    })}
    </ul>;
}